import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { ComumModule } from './../../../shared/comum.module';
import { QuartilCadastroComponent } from './quartil-cadastro/quartil-cadastro.component';
import { QuartilFiltroComponent } from './quartil-filtro/quartil-filtro.component';
import { QuartilListaComponent } from './quartil-lista/quartil-lista.component';
import { QuartilService } from './quartil-service/quartil.service';
import { QuartilComponent } from './quartil.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule
  ],
  exports: [
    QuartilComponent
  ],
  declarations: [
    QuartilComponent,
    QuartilListaComponent,
    QuartilCadastroComponent,
    QuartilFiltroComponent
  ],
  providers: [
    QuartilService
  ]
})
export class QuartilModule { }
